export const ROUND_OPTIONS = [
  {code: "R16", name: "16강"},
  {code: "QF", name: "8강"},
  {code: "SF", name: "4강"},
  {code: "THIRD", name: "3.4위전"},
  {code: "FINAL", name: "결승"},
];

export const EVENT_STATUS_OPTIONS = [
  {value: "DRAFT", label: "준비중"},
  {value: "ACTIVE", label: "진행중"},
  {value: "ENDED", label: "종료"},
];

export const ROUND_STATUS_LABEL = {
  PENDING: "오픈 예정",
  OPEN: "진행 중",
  CLOSED: "종료",
};

export const MATCH_STATUS_LABEL = {
  SCHEDULED: "예측 가능",
  BETTING_CLOSED: "예측 마감",
  LIVE: "경기 진행",
  FINISHED: "종료",
  CANCELLED: "취소",
};

export function roundName(code) {
  return ROUND_OPTIONS.find((r) => r.code === code)?.name ?? code;
}

/** ISO 3166-1 alpha-2 (BR, MX) — FlagCDN과 1:1 */
export const FLAG_CDN_WIDTH = 80;

export function normalizeTeamCode(code) {
  return (code ?? "").trim().toUpperCase();
}

export function isValidAlpha2TeamCode(code) {
  return /^[A-Z]{2}$/.test(normalizeTeamCode(code));
}

export function buildFlagUrl(teamCode, width = FLAG_CDN_WIDTH) {
  const normalized = normalizeTeamCode(teamCode);
  if (!isValidAlpha2TeamCode(normalized)) {
    return "";
  }
  return `https://flagcdn.com/w${width}/${normalized.toLowerCase()}.png`;
}
